import { render, staticRenderFns } from "./UserUpdatePasswordDialog.vue?vue&type=template&id=0e251014&scoped=true&"
import script from "./UserUpdatePasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserUpdatePasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e251014",
  null
  
)

export default component.exports